// THE ONE PAIR EVERY STRAND WEARS, across every group.
//
// Named here rather than repeated on ~17 lines so a recolour is a single
// edit. The whole ensemble is meant to read as ONE strike hitting from
// several directions at once, and that only holds if no group drifts onto a
// palette of its own.
//
// Not to be confused with LIGHTNING_INNER_COLOR in ./index.ts -- that is the
// fallback the renderer uses when a line omits `innerColor` entirely (see
// index.tsx), and it is still the warm default for the procedural seeds.
export const LIGHTNING_STRIKE_COLOR = '#ff2424';
export const LIGHTNING_STRIKE_INNER_COLOR = '#ff0f0f';
